import { defaultStatus } from "../defaultState/defaultState";
import {
  ADD_SECURITY_OFFICER_FAILURE,
  ADD_SECURITY_OFFICER_REQUEST,
  ADD_SECURITY_OFFICER_SUCCESS,
  DELETE_SECURITY_OFFICER_FAILURE,
  DELETE_SECURITY_OFFICER_REQUEST,
  DELETE_SECURITY_OFFICER_SUCCESS,
  FETCH_LIST_SECURITY_OFFICERS_FAILURE,
  FETCH_LIST_SECURITY_OFFICERS_REQUEST,
  FETCH_LIST_SECURITY_OFFICERS_SUCCESS,
  FETCH_SECURITY_OFFICER_FAILURE,
  FETCH_SECURITY_OFFICER_REQUEST,
  FETCH_SECURITY_OFFICER_SUCCESS,
  RESET_CURRENT_SECURITY_OFFICER,
  UPDATE_SECURITY_OFFICER_FAILURE,
  UPDATE_SECURITY_OFFICER_REQUEST,
  UPDATE_SECURITY_OFFICER_SUCCESS,
} from "./securityType";

const initialState = {
  securityOfficers: [],
  currentSecurityOfficer: null,
  fetchSecurityOfficers: { ...defaultStatus },
  fetchSecurityOfficer: { ...defaultStatus },
  addSecurityOfficer: { ...defaultStatus },
  updateSecurityOfficer: { ...defaultStatus },
  deleteSecurityOfficer: { ...defaultStatus },
  formMode: null, // 'add' or 'edit'
};

const securityOfficerReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    // List security officers
    case FETCH_LIST_SECURITY_OFFICERS_REQUEST:
      return {
        ...state,
        fetchSecurityOfficers: {
          ...state.fetchSecurityOfficers,
          inProgress: true,
        },
      };
    case FETCH_LIST_SECURITY_OFFICERS_SUCCESS:
      return {
        ...state,
        fetchSecurityOfficers: {
          ...state.fetchSecurityOfficers,
          success: true,
          inProgress: false,
          data: payload?.securityOfficers?.data,
        },
      };
    case FETCH_LIST_SECURITY_OFFICERS_FAILURE:
      return {
        ...state,
        fetchSecurityOfficers: {
          ...state.fetchSecurityOfficers,
          error: true,
          errorMessage: payload.error,
        },
      };

    // View single security officer
    case FETCH_SECURITY_OFFICER_REQUEST:
      return {
        ...state,
        fetchSecurityOfficer: {
          ...state.fetchSecurityOfficer,
          inProgress: true,
        },
      };
    case FETCH_SECURITY_OFFICER_SUCCESS:
      return {
        ...state,
        fetchSecurityOfficer: {
          ...state.fetchSecurityOfficer,
          success: true,
          inProgress: false,
          data: payload?.securityOfficer?.data,
        },
      };
    case FETCH_SECURITY_OFFICER_FAILURE:
      return {
        ...state,
        fetchSecurityOfficer: {
          ...state.fetchSecurityOfficer,
          error: true,
          errorMessage: payload.error,
        },
      };

    // Add security officer
    case ADD_SECURITY_OFFICER_REQUEST:
      return {
        ...state,
        addSecurityOfficer: { ...state.addSecurityOfficer, inProgress: true },
      };
    case ADD_SECURITY_OFFICER_SUCCESS:
      return {
        ...state,
        addSecurityOfficer: {
          ...state.addSecurityOfficer,
          success: true,
          inProgress: false,
          error: false,
          data: payload.securityOfficer,
        },
      };
    case ADD_SECURITY_OFFICER_FAILURE:
      return {
        ...state,
        addSecurityOfficer: {
          ...state.addSecurityOfficer,
          error: true,
          inProgress: false,
          success: false,
          errorMessage: payload.error,
        },
      };

    case UPDATE_SECURITY_OFFICER_REQUEST:
      return {
        ...state,
        updateSecurityOfficer: {
          ...state.updateSecurityOfficer,
          inProgress: true,
        },
      };
    case UPDATE_SECURITY_OFFICER_SUCCESS: {
      return {
        ...state,
        updateSecurityOfficer: {
          ...state.addSecurityOfficer,
          success: true,
          error: false,
          inProgress: false,
          data: payload.securityOfficer,
        },
      };
    }
    case UPDATE_SECURITY_OFFICER_FAILURE:
      return {
        ...state,
        updateSecurityOfficer: {
          ...state.updateSecurityOfficer,
          error: true,
          errorMessage: payload.error,
        },
      };

    // Delete security officer
    case DELETE_SECURITY_OFFICER_REQUEST:
      return {
        ...state,
        deleteSecurityOfficer: {
          ...state.deleteSecurityOfficer,
          inProgress: true,
        },
      };
    case DELETE_SECURITY_OFFICER_SUCCESS:
      return {
        ...state,
        deleteSecurityOfficer: {
          ...state.deleteSecurityOfficer,
          success: true,
          inProgress: false,
        },
        securityOfficers: state.securityOfficers.filter(
          (securityOfficer) => securityOfficer.id !== payload.securityOfficerId
        ),
        currentSecurityOfficer:
          state.currentSecurityOfficer?.id === payload.securityOfficerId
            ? null
            : state.currentSecurityOfficer,
      };
    case DELETE_SECURITY_OFFICER_FAILURE:
      return {
        ...state,
        deleteSecurityOfficer: {
          ...state.deleteSecurityOfficer,
          error: true,
          errorMessage: payload.error,
        },
      };

    case RESET_CURRENT_SECURITY_OFFICER:
      return { ...initialState };

    default:
      return state;
  }
};

export default securityOfficerReducer;
